export function IconChevronBarExpand() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.64645 10.1464C3.84171 9.95118 4.15829 9.95118 4.35355 10.1464L8 13.7929L11.6464 10.1464C11.8417 9.95118 12.1583 9.95118 12.3536 10.1464C12.5488 10.3417 12.5488 10.6583 12.3536 10.8536L8.35355 14.8536C8.15829 15.0488 7.84171 15.0488 7.64645 14.8536L3.64645 10.8536C3.45118 10.6583 3.45118 10.3417 3.64645 10.1464Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.64645 5.85355C3.84171 6.04882 4.15829 6.04882 4.35355 5.85355L8 2.20711L11.6464 5.85355C11.8417 6.04882 12.1583 6.04882 12.3536 5.85355C12.5488 5.65829 12.5488 5.34171 12.3536 5.14645L8.35355 1.14645C8.15829 0.951184 7.84171 0.951184 7.64645 1.14645L3.64645 5.14645C3.45118 5.34171 3.45118 5.65829 3.64645 5.85355Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8C1 7.72386 1.22386 7.5 1.5 7.5L14.5 7.5C14.7761 7.5 15 7.72386 15 8C15 8.27614 14.7761 8.5 14.5 8.5L1.5 8.5C1.22386 8.5 1 8.27614 1 8Z"
        fill="currentColor"
      />
    </svg>
  );
}
